package org.tlsys.serialization

import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable
import org.tlsys.Phone

@Serializable
data class SMSTestData(@Contextual val phone: Phone, val text: String)
